<template>
<form id="addressUpdateForm" method="post">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Update User Custom Features</h5>

            <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
          </div>
          <div class="modal-body">

            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <h3>Enable Account Flags</h3>
                        <div class="form-group" v-for="(item, index) in customfeatures" v-bind:key="index">
                          <input class="form-check-input me-2" type="checkbox" :id="item.name" :name="item.name" :checked="checkFlag(item.name)" @change="toggleOption(item.name)">
                          <label class="form-check-label" :for="item.name">{{ item.title }}</label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h3>Add Custom Script</h3>
                        <div class="row align-items-center mb-2">
                                <vue3-simple-typeahead
                                    id="typeahead_id"
                                    placeholder="Enter script name..."
                                    :items="customscripts"
                                    :minInputLength="1"
                                    :itemProjection="itemProjectionFunction"
                                    @selectItem="selectItemEventHandler"
                                    @onInput="onInputEventHandler"
                                    @onFocus="onFocusEventHandler"
                                    @onBlur="onBlurEventHandler"
                                    class="form-control input-lg"
                                >
                                </vue3-simple-typeahead>
                            </div>
                        <div class="row" v-for="(item, index) in userscripts" v-bind:key="index">
                            <div class="col">
                                <div class="card card-body">
                                  <div class="container-fluid p-2">
                                    <a class="btn btn-sm btn-danger float-end mb-2 ml-2" @click="deleteSelectedScript(item)"><i class="fas fa-trash-alt"></i></a>
                                    <h4>{{ item.name }}</h4>
                                    <p>{{ item.description }}</p>
                                  </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
            <button type="button" class="btn btn-primary" @click="onSubmit">Update</button>
          </div>
        </div>
      </form>
</template>
<script>
import SimpleTypeahead from 'vue3-simple-typeahead'
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'
import axios from 'axios';
import jsonData from '../../custom_scripts_repo.json';
export default {
  name: 'ModalEditUsersSession',
  components: { SimpleTypeahead },
  data () {
    return {
      zcataccess: false,
      customscripts: [],
      customfeatures: [],
      userscripts: [],
      userfeatures: [],
      importedscriptdata: jsonData
    }
  },
  props: {
    passedModalData: []
  },
  methods: {
    toggleOption(option) {
      console.log("Checkbox changed:", option);
      var finvar = option;
      var theuuid = this.passedModalData.uid;
      var checkbox = document.getElementById(option);
      if (checkbox.checked) {
        var thecmd = 'set';
      } else {
        var thecmd = 'clear';
      };
       axios.get('/script_readable_variable', { params: {varname: finvar, cmd: thecmd, uuid: theuuid}}) 
      .then(
			(response) => {
        console.log('toggle response: '+response.data);
      })
      .catch(
			(error) => {
        console.log(error);
        console.log('form submit failed');
      });

    },
    deleteSelectedScript(script) {
      console.log('selected script to delete '+JSON.stringify(script));
      console.log('selected script to delete NAME ONLY '+JSON.stringify(script.value));

      let formData = new FormData();
        formData.append('name', script.value);
        formData.append('uuid', this.passedModalData.uid);

        axios({
          method: 'POST',
          url: '/delete_user_script',
          data: formData
        })
        .then(response => {
          var curArray = Array.isArray(response.data) ? response.data : Object.values(response.data);
            var tempArr = [];
            curArray.forEach(function (item, index) {
                tempArr.push({ value: item[0], name: item[1], description: item[2] });
            });
            this.userscripts = tempArr;
          console.log('ADD user script submitted: '+response.data);
        })
        .catch(error => {
          console.error("Error adding script:", error);
        });

    },
    gatherScripts() {
        var newlist = [];
    
        for (var i=0; i < this.importedscriptdata.length; i++) {
            if (this.importedscriptdata[i].type === "script") {
                newlist.push({ type: this.importedscriptdata[i].type, name: this.importedscriptdata[i].name, title: this.importedscriptdata[i].title, description: this.importedscriptdata[i].description,path: this.importedscriptdata[i].path });
            }
        }
        this.customscripts = newlist;
    },
    gatherAvailableFlags() {
        var newlist = [];
    
        for (var i=0; i < this.importedscriptdata.length; i++) {
            if (this.importedscriptdata[i].type === "flag") {
                newlist.push({"title":this.importedscriptdata[i].title, "name":this.importedscriptdata[i].name, "path":this.importedscriptdata[i].path});
            }
        }
        
        this.customfeatures = newlist;
        // console.log(JSON.stringify(this.customfeatures));
    },
    gatherUserFlags() {
        console.log('this user ID is '+this.passedModalData.uid);
        let formData = new FormData();
        formData.append('uuid', this.passedModalData.uid);
        axios({
              method : 'POST',
              url : '/get_flags_list',
              data: formData,
          })
        .then(
          (response) => {  
            console.log('response '+JSON.stringify(response.data));
            var flagArray = Array.isArray(response.data) ? response.data : Object.values(response.data);
            var tempFlagArr = [];
            flagArray.forEach(function (item, index) {
                tempFlagArr.push({ item });
            });
            this.userfeatures = tempFlagArr;
            //console.log('users features '+JSON.stringify(this.userfeatures));
            
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
          console.error("There was an error", error);
      });
    },
    checkFlag(val) {
        return this.userfeatures.some(feature => feature.item === val);
    },
    itemProjectionFunction(item) {
      return item.title;
    },
    selectItemEventHandler(item) {
      // Get the selected script details from importedscriptdata
      //console.log('Item selected! '+item.name+' - Path: '+item.path);
      // const selectedScript = this.importedscriptdata.find(script => script.title === item.title);
      
      //if (selectedScript) {
        let formData = new FormData();
        formData.append('name', item.name);
        formData.append('path', item.path);
        formData.append('uuid', this.passedModalData.uid);

        axios({
          method: 'POST',
          url: '/add_user_script',
          data: formData
        })
        .then(response => {
          var curArray = Array.isArray(response.data) ? response.data : Object.values(response.data);
            var tempArr = [];
            curArray.forEach(function (item, index) {
                tempArr.push({ value: item[0], name: item[1], description: item[2] });
            });
            this.userscripts = tempArr;
          console.log('ADD user script submitted: '+response.data);
        })
        .catch(error => {
          console.error("Error adding script:", error);
        });
      //}
    },
    gatherUserScripts() {
        // console.log('this user ID is '+this.passedModalData.uid);
        let formData = new FormData();
        formData.append('uuid', this.passedModalData.uid);
        axios({
              method : 'POST',
              url : '/get_script_list',
              data: formData,
          })
        .then(
          (response) => {  
            //console.log('response '+JSON.stringify(response.data));
            var curArray = Array.isArray(response.data) ? response.data : Object.values(response.data);
            var tempArr = [];
            curArray.forEach(function (item, index) {
                tempArr.push({ value: item[0], name: item[1], description: item[2] });
            });
            this.userscripts = tempArr;
            //console.log('user scripts '+JSON.stringify(this.userscripts));
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
          console.error("There was an error", error);
      });
    }
  },
  mounted() {
    //console.log('passed modal data '+this.passedModalData);
    this.gatherUserScripts();
    this.gatherScripts();
    this.gatherAvailableFlags();
    this.gatherUserFlags();
    //console.log('total imported script data '+JSON.stringify(this.importedscriptdata));
    //console.log('imported filtered script '+JSON.stringify(this.customscripts));
  }
}
</script>